module.exports = __webpack_public_path__ + "img/banner1.4f634146.png";